import { NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ErrorHandlerModule } from 'src/app/modules/error-handler/error-handler.module';
import { NotifierModule } from 'src/app/modules/notifier/notifier.module';
import { NotifierService } from 'src/app/modules/notifier/notifier.service';
import { OfiRouterModule } from 'src/app/modules/ofi-router/ofi-router-module';
import { SentryLoggingModule } from 'src/app/modules/sentry/sentry.module';
import APP_CONFIG from '../webpack/extra-webpack-types';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

/**
 * The main application module containing the core module, shared module, and any feature modules.
 * initialized, the main application component will be created.
 */
@NgModule({
    declarations: [ AppComponent ],
    imports: [
        CoreModule,
        ErrorHandlerModule.forRoot(),
        SentryLoggingModule.forRoot(),
        StoreModule.forRoot({}, {}),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: APP_CONFIG.production,
            connectInZone: true }),
        EffectsModule.forRoot([]),
        OfiRouterModule,
        // App Routing must be imported last
        AppRoutingModule,
        NotifierModule
    ],
    providers: [
        Title,
        { provide: 'ENV', useValue: APP_CONFIG },
        // Error Handling:
        {
            provide: 'ERROR_HANDLER_OPTIONS',
            useValue: APP_CONFIG.errorHandlerOptions
        },
        {
            provide: 'ERROR_LOGGER_OPTIONS',
            useValue: APP_CONFIG.errorLoggerOptions
        },
        // Other
        { provide: 'AUTHENTICATION_API', useValue: APP_CONFIG.authenticationApi },
        { provide: 'PORTAL_URL', useValue: APP_CONFIG.portalUrl },
        { provide: 'NOTIFICATION_SERVICE', useClass: NotifierService },
        {
            provide: 'LOGIN_URL',
            useValue: APP_CONFIG.errorHandlerOptions.authRedirectUrl
        }
    ],
    bootstrap: [ AppComponent ]
})
export class AppModule {}
